export default function IconButton(theme) {
    return {
        MuiIconButton: {
            styleOverrides: {
                root: {
                    borderRadius: '8px'
                },
                sizeLarge: {
                    width: '48px',
                    height: '48px',
                    fontSize: '32px'
                },
                sizeMedium: {
                    width: '40px',
                    height: '40px',
                    borderRadius: '8px',
                },
                sizeSmall: {
                    width: '36px',
                    height: '36px',
                    fontSize: '20px'
                },
                sizeXs: {
                    width: '32px',
                    height: '32px'
                }
            }
        }
    };
}
